import { number, string } from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const ReactivateSvg = styled.svg`
  width: ${prop('size', 16)}px;
  height: ${prop('size', 16)}px;
  margin: 0 4px;

  .a {
    fill: none;
    stroke: ${prop('color', colorsOptions.greys['grey-100'])};
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    stroke-width: 1.5px;
  }

  &:hover {
    cursor: pointer;
    .a {
      stroke: ${prop('hoverColor', colorsOptions.greys['grey-100'])};
    }
  }
`

function ReactivateIcon({ color, hoverColor, size, ...props }) {
  return (
    <ReactivateSvg
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
      viewBox="0 0 17.501 19.31"
    >
      <g transform="translate(-145.75 -137.75)">
        <path
          className="a"
          d="M19.484,15.153l4.459-.693L23.249,10l.693,4.454A8,8,0,1,0,26,19.809"
          transform="translate(136.5 128.5)"
        />
      </g>
    </ReactivateSvg>
  )
}

ReactivateIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number,
}

export default ReactivateIcon
